import moment from 'moment';

export function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export function defaultFormatDate(value, locale) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const datePart = date.toLocaleDateString(locale || 'ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const timePart = date.toLocaleTimeString(locale || 'ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${datePart} ${timePart}`;
}

function formatShortName({ surName, firstName, patrName }) {
  const initials = [firstName, patrName]
    .filter(Boolean)
    .map((part) => `${part[0].toUpperCase()}.`)
    .join(' ');
  return [surName, initials].filter(Boolean).join(' ');
}

export function getCommentAuthor(comment) {
  return comment?.worker || comment?.author || null;
}

export function defaultFormatAuthor(worker) {
  if (!worker) return '';
  const { specialityName, speciality, surName, fullName, companyName } = worker;
  const name = surName ? formatShortName(worker) : fullName;
  return [specialityName || speciality, name, companyName]
    .filter(Boolean)
    .join(' ');
}

export function isCommentOwnedByUser(comment, currentUserId) {
  if (!comment || currentUserId == null || currentUserId === '') return false;
  const authorId = getCommentAuthor(comment)?.id ?? comment.authorId;
  return authorId != null && String(authorId) === String(currentUserId);
}

export function getCommentText(comment) {
  return comment?.comment ?? comment?.text ?? '';
}

export function getCommentDate(comment) {
  return comment?.addDate ?? comment?.createdAt;
}

export function sortByDateDesc(comments) {
  return [...(comments || [])].sort((a, b) => {
    const aTime = moment(getCommentDate(a));
    const bTime = moment(getCommentDate(b));
    return aTime.diff(bTime);
  });
}
